import { useState, useEffect } from "react"
import styles from './TextScroller.module.scss';
import useWindowDimensions, { CurrentScreen } from "../../../hooks/use-window-dimensions";

interface TextScrollerProps {
  texts: string[]
  height?: number // Height of each text item, for consistent scrolling
  interval?: number // Time in ms between text changes
}

export default function TextScroller({
  texts,
  height = 96, // Default height based on visual estimation from the image
  interval = 3000, // Default interval of 3 seconds
}: TextScrollerProps) {
  const [currentIndex, setCurrentIndex] = useState(0)

  const currentScreen: CurrentScreen = useWindowDimensions();

  const _height = currentScreen.isMobile ? 48 : height;

  useEffect(() => {
    if (texts.length === 0) return

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length)
    }, interval)

    return () => clearInterval(timer)
  }, [texts, interval])

  return (
    <div className={styles.textScrollerContainer} style={{ height: `${_height}px` }}>
      <div className={styles.textWrapper} style={{ transform: `translateY(-${currentIndex * _height}px)` }}>
        {texts.map((text, index) => (
          <h3 key={index} className={styles.textItem} style={{ height: `${_height}px` }}>
            {text}
          </h3>
        ))}
      </div>
    </div>
  )
}